import React, { useCallback } from 'react';
import { DateUtils } from '@vectord/utils';
import { Tappable } from '@vectord/components';
import { batch, useDispatch } from 'react-redux';
import pluralize from 'pluralize';

import {
  COURSE_PAUSE_RESCHEDULE_MODAL_STAGES,
  CoursePauseNotePopover,
  LearnerInfoPopover,
  setCoursePauseRescheduleModalStage,
  setSelectedRequest,
} from 'features/courseResume';
import styles from './CoursePauseScheduledTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function CoursePauseScheduledTableRow({ request }) {
  const dispatch = useDispatch();
  const {
    duration_of_pause: durationOfPause,
    pause_date: pauseDate,
    scheduled_resume_date: scheduledResumeDate,
    destination_batch: destinationBatch,
  } = request;
  const { super_batch: superBatch } = destinationBatch || {};

  const handleRescheduleButtonClick = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(request));
      dispatch(
        setCoursePauseRescheduleModalStage(
          COURSE_PAUSE_RESCHEDULE_MODAL_STAGES.manage
        )
      );
    });
  }, [dispatch, request]);

  return (
    <>
      <TableRow className={styles.root}>
        <TableCell className={styles.cell}>
          <LearnerInfoPopover request={request} />
        </TableCell>
        <TableCell className={styles.cell}>
          {DateUtils.toDDMMYYYY(pauseDate)}
        </TableCell>
        <TableCell className={styles.cell}>
          {pluralize('Month', durationOfPause, true)}
        </TableCell>
        <TableCell className={styles.cell}>
          {superBatch?.name || 'N/A'}
        </TableCell>
        <TableCell className={styles.cell}>
          {(scheduledResumeDate &&
            DateUtils.toDateDayTime(scheduledResumeDate)) ||
            'N/A'}
        </TableCell>
        <TableCell className={styles.cell}>
          <CoursePauseNotePopover request={request} />
        </TableCell>
        <TableCell className={styles.action}>
          <Tappable
            className="primary"
            noHighlight
            onClick={handleRescheduleButtonClick}
          >
            Reschedule
          </Tappable>
        </TableCell>
      </TableRow>
    </>
  );
}

export default CoursePauseScheduledTableRow;
